import { render } from "./BackupContentModal.vue?vue&type=template&id=cb87a56e"
import script from "./BackupContentModal.vue?vue&type=script&lang=js"
export * from "./BackupContentModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__